import React from 'react';
import { Box } from '@mui/material';
import dayjs from 'dayjs';
import { Dialog } from '../../../../Components/MUIs';
import './SerEvalFinalSaveConfirmDialog.styles.css';

/** 중대재해 평가 최종 저장(확정) 확인 다이얼로그 */
function SerEvalFinalSaveConfirmDialog({
  open = false,
  formName = '',
  formVer = '',
  evaName = '',
  evaDate = '',
  totalPoint = 0,
  custNm = '',
  onClose,
  onConfirm,
}) {
  const displayFormName =
    String(formName || '').trim() || '평가 양식';
  const displayEvaName = String(evaName || '').trim() || '미입력';
  const displayDate = evaDate
    ? dayjs(evaDate).isValid()
      ? dayjs(evaDate).format('YYYY-MM-DD')
      : String(evaDate).slice(0, 10)
    : '-';
  const displayScore = Number.isFinite(Number(totalPoint))
    ? Math.round(Number(totalPoint))
    : 0;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="최종 저장"
      maxWidth="sm"
      fullWidth
      useSaveButton={false}
      useCloseButton={false}
      titleSx={{ pb: 2, fontWeight: 700 }}
      contentSx={{ pt: 3, px: 2.5, pb: 2 }}
      actions={
        <div className="ser-final-dialog__actions">
          <button
            type="button"
            className="ser-final-dialog__btn ser-final-dialog__btn--cancel"
            onClick={onClose}
          >
            취소
          </button>
          <button
            type="button"
            className="ser-final-dialog__btn ser-final-dialog__btn--confirm"
            onClick={onConfirm}
          >
            <span className="material-symbols-outlined">verified</span>
            최종저장
          </button>
        </div>
      }
      content={
        <Box
          className="ser-final-dialog"
          sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <div className="ser-final-dialog__intro">
            <div className="ser-final-dialog__intro-icon">
              <span className="material-symbols-outlined">verified</span>
            </div>
            <div>
              <div className="ser-final-dialog__intro-title">
                평가를 최종 저장(확정)합니다
              </div>
              <p className="ser-final-dialog__intro-desc">
                확정 후에는 평가 내용을 수정할 수 없습니다. 계속
                진행하시겠습니까?
              </p>
            </div>
          </div>

          <div className="ser-final-dialog__target-card">
            <div className="ser-final-dialog__target-label">확정할 평가</div>
            <div className="ser-final-dialog__target-name">
              <span className="ser-final-dialog__target-icon">
                <span className="material-symbols-outlined">assignment</span>
              </span>
              <div className="ser-final-dialog__target-text">
                {custNm ? (
                  <span className="ser-final-dialog__target-cust">{custNm}</span>
                ) : null}
                <span className="ser-final-dialog__target-form">
                  {displayFormName}
                </span>
              </div>
            </div>
            <div className="ser-final-dialog__meta">
              <span className="ser-final-dialog__meta-item">
                <span className="material-symbols-outlined">person</span>
                평가자 {displayEvaName}
              </span>
              <span className="ser-final-dialog__meta-item">
                <span className="material-symbols-outlined">calendar_today</span>
                평가일 {displayDate}
              </span>
              <span className="ser-final-dialog__meta-item">
                <span className="material-symbols-outlined">score</span>
                총 취득점수 {displayScore}점
              </span>
            </div>
          </div>

          <div className="ser-final-dialog__notice">
            <span className="material-symbols-outlined">info</span>
            <span>
              최종 저장하면 평가 상태가 「확정」으로 변경되며, 이후
              임시저장·수정이 불가능합니다.
            </span>
          </div>
        </Box>
      }
    />
  );
}

export default SerEvalFinalSaveConfirmDialog;
